import React, { useCallback } from 'react'
import { useHistory } from 'react-router'
import routes from '../../../config/routes'
import BoyContent from '../../commons/Ilustrations/BoyContent'
import FeedbackLayout from '../../commons/Layouts/FeedbackLayout'
import styles from './peopleDetail.module.scss'

export const TITLE = 'Clientes'
export const SUBTITLE =
  'Esse consultor ainda não possui lojas em sua carteira. Clique em ”Adicionar lojas” para adicionar a primeira.'

const PeopleWalletEmpty = () => {
  const history = useHistory()

  const redirectToWallet = useCallback(() => {
    history.push(routes.wallet.path)
  }, [])

  return (
    <div className={styles.empty}>
      <FeedbackLayout
        center
        title={TITLE}
        subTitle={SUBTITLE}
        Ilustration={() => <BoyContent />}
        secondaryLabelAction="Ir para carteira"
        secondaryAction={redirectToWallet}
      />
    </div>
  )
}

export default React.memo(PeopleWalletEmpty)
